import $i18n from '@alife/panda-i18n';
// 上架作业单 单号
const PUTON_TYPE = [
  {
    label: $i18n.get({ id: 'ContainerShelving.four_px', dm: '容器上架' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'SkuShelving.four_px', dm: 'SKU上架' }),
    value: 'A',
  },
];

// 上架异常 上架类型
const ABNOR_PUTON_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'StorageShelving.four_px', dm: '存储区上架' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'PickingAreaShelving.four_px', dm: '拣选区上架' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'SortingAndShelting', dm: '分拣上架' }),
    value: 'SP',
  },

  // {
  //   label: $i18n.get({ id: 'SkuShelving.four_px', dm: 'SKU上架' }),
  //   value: 'S',
  // },
];

const ABNOR_PUTON_TYPE_LIST = [
  {
    label: $i18n.get({ id: 'StorageShelving.four_px', dm: '存储区上架' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'PickingAreaShelving.four_px', dm: '拣选区上架' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'SkuShelving.four_px', dm: 'SKU上架' }),
    value: 'S',
  },
  {
    label: $i18n.get({ id: 'SortingAndShelting', dm: '分拣上架' }),
    value: 'SP',
  },
];

const NEW_PUTAWAY_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'StorageShelving.four_px', dm: '存储区上架' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'PickingAreaShelving.four_px', dm: '拣选区上架' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'SortingAndShelting', dm: '分拣上架' }),
    value: 'SP',
  },
];

// 上架作业单 上架类型？？？
const PUTAWAY_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'Walking.four_px', dm: '行走' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: 'D',
  },
];

// 新增收货类型
const NEW_RECEIPT_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'StorageReceiving.four_px', dm: '存储区收货' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'PickingAreaReceiving.four_px', dm: '拣选区收货' }),
    value: 'C',
  },
  {
    label: $i18n.get({ id: 'SortingReceipt', dm: '分拣收货' }),
    value: 'S',
  },
];

// 收货类型
const RECEIPT_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'ContainerReceipt.four_px', dm: '容器收货' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'EntireOrderReceipt.four_px', dm: '整单收货' }),
    value: 'A',
  },
];

// Tab状态
const TAB_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'NotStarted.four_px', dm: '未开始' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'InProgress.four_px', dm: '进行中' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'F',
  },

  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'X',
  },
];

// 收货作业单 单号
const RECEIPT_NO = [
  {
    label: $i18n.get({ id: 'InboundOrderNo.four_px', dm: '入库订单号' }),
    value: 'consignmentNo',
  },

  {
    label: $i18n.get({ id: 'ReceivingJobNo.four_px', dm: '收货作业单号' }),
    value: 'jobNo',
  },
];

// 上架异常时间
const PUTAWAY_ABNOR_TIME = [
  {
    label: $i18n.get({ id: 'DeliveryTime.four_px', dm: '收货时间' }),
    value: 'receiveTime',
  },

  {
    label: $i18n.get({ id: 'TargetShelvingTime.four_px', dm: '目标上架时间' }),
    value: 'expectPutawayDate',
  },
];

// 收货异常时间
const RECEIPT_ANBOR_TIME = [
  {
    label: $i18n.get({ id: 'DeliveryTime.four_px', dm: '收货时间' }),
    value: 'receiveTime',
  },

  {
    label: $i18n.get({ id: 'TargetShelvingTime.four_px', dm: '目标上架时间' }),
    value: 'expectPutawayDate',
  },
];

// 卸货异常时间
const DISCHARGE_ANBOR_TIME = [
  {
    label: $i18n.get({ id: 'StartTime.four_px', dm: '开始时间' }),
    value: 'startTime',
  },

  {
    label: $i18n.get({ id: 'TargetShelvingTime.four_px', dm: '目标上架时间' }),
    value: 'expectPutawayDate',
  },
];

// 库存质量
const STOCK_QUALITY = [
  {
    label: $i18n.get({ id: 'Good.four_px', dm: '良好' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'Damaged.four_px', dm: '破损' }),
    value: 'B',
  },

  {
    label: $i18n.get({ id: 'YC.Exception.four_px', dm: '异常' }),
    value: 'E',
  },

  {
    label: $i18n.get({ id: 'ReturnedItems.four_px', dm: '退件品' }),
    value: 'R',
  },
];

// 业务类型
const BUSINESSTYPE = [
  {
    label: $i18n.get({ id: 'StandardOutbound.four_px', dm: '标准出库' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'UnshelvingAndDestroying.four_px', dm: '下架销毁' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'WarehouseWithdrawal.four_px', dm: '退仓出库' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'DropshippingCheckedOut.four_px', dm: 'DropShipping出库' }),
    value: 'DS',
  },

  {
    label: $i18n.get({ id: 'OtherOutbound.four_px', dm: '其他出库' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'TransferOrder.four_px', dm: '调拨委托单' }),
    value: 'T',
  },
];

// 操作步骤代码
const OPERATIONCODE = [
  {
    label: $i18n.get({ id: 'Unloading.four_px', dm: '卸货' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: 'Receipt.four_px', dm: '收货' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: 'P',
  },
];

// 入库服务器地址
const INBOUNDSERVICE = 'portal';

// 移库管理
// 上架货型
const CARGO_TYPE_LIST = [
  {
    label: 'T25',
    value: 'S',
  },

  {
    label: 'T50',
    value: 'M',
  },

  {
    label: 'T120',
    value: 'L',
  },

  {
    label: 'T240',
    value: 'O',
  },

  {
    label: 'TM',
    value: 'W',
  },
];

// 打包
// 打包TAB
const PAKEAGE_TAB = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'InProgress.four_px', dm: '进行中' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'NotStarted.four_px', dm: '未开始' }),
    value: 'W',
  },
];

// 打包状态
const PAKEAGE_TAB_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'InProgress.four_px', dm: '进行中' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'F',
  },

  {
    label: $i18n.get({ id: 'NotStarted.four_px', dm: '未开始' }),
    value: 'W',
  },
];

// 预约 -> 提柜管理 无排队预约
// 预约类型
const RESERVATIONTYPE = [
  {
    label: $i18n.get({ id: 'DeliveryAppointment.four_px', dm: '收货预约' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'ValueAddedReservation.four_px', dm: '增值预约' }),
    value: 'V',
  },

  {
    label: $i18n.get({ id: 'ArrangementReservation.four_px', dm: '排仓预约' }),
    value: 'W',
  },

  // {
  //   label: $i18n.get({ id: 'QueueForAppointment.four_px', dm: '排队预约' }),
  //   value: 'R',
  // },
  {
    label: $i18n.get({ id: 'AutomaticReservation.four_px', dm: '自动预约' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },
];

// 封铅状态
const RESERVATION_LEAD_SEAL_STATUS = [
  {
    label: $i18n.get({ id: 'Normal.four_px', dm: '正常' }),
    value: 'N',
  },
  {
    label: $i18n.get({ id: 'YC.Exception.four_px', dm: '异常' }),
    value: 'E',
  },
  {
    label: $i18n.get({ id: 'CardPieWithoutLeadSeal', dm: '卡派无铅封1' }),
    value: 'TN',
  },
];

// 是否有POD
const RESERVATION_HAS_POD = [
  {
    label: $i18n.get({ id: 'Is.four_px', dm: '是' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'F.No.four_px', dm: '否' }),
    value: 'N',
  },
];

// 预约 -> 提柜管理 有排队预约
// 预约类型
const RESERVATIONTYPES = [
  {
    label: $i18n.get({ id: 'DeliveryAppointment.four_px', dm: '收货预约' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'ValueAddedReservation.four_px', dm: '增值预约' }),
    value: 'V',
  },

  {
    label: $i18n.get({ id: 'ArrangementReservation.four_px', dm: '排仓预约' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'QueueForAppointment.four_px', dm: '排队预约' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'AutomaticReservation.four_px', dm: '自动预约' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },
];

// 预约 -> 提柜管理
// 收货状态
const SHOUHUOSTATE = [
  {
    label: $i18n.get({ id: 'MakingAnAppointment.four_px', dm: '预约中' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Confirmed.four_px', dm: '已确认' }),
    value: 'F',
  },

  {
    label: $i18n.get({ id: 'Receiving.four_px', dm: '收货中' }),
    value: 'V',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'X',
  },

  // {
  //   label: '已拒绝',
  //   value: 'R',
  // },
  // {
  //   label: '已取消',
  //   value: 'X',
  // },
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },
];

// 预约 -> 提柜管理
// 柜型
const CONTAINERTYPE = [
  {
    label: '20GP',
    value: '20GP',
  },

  {
    label: '20HQ',
    value: '20HQ',
  },

  {
    label: '40GP',
    value: '40GP',
  },

  {
    label: '40HQ',
    value: '40HQ',
  },

  {
    label: '45HQ',
    value: '45HQ',
  },

  {
    label: 'FTL',
    value: 'FTL',
  },
];

// 移库状态
const YIKUSTATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '999',
  },

  {
    label: $i18n.get({ id: 'Unshelving.four_px', dm: '下架中' }),
    value: '10',
  },

  {
    label: $i18n.get({ id: 'Removed.four_px', dm: '已下架' }),
    value: '11',
  },

  {
    label: $i18n.get({ id: 'Shelving.four_px', dm: '上架中' }),
    value: '20',
  },

  {
    label: $i18n.get({ id: 'Shelved.four_px', dm: '已上架' }),
    value: '30',
  },
];

// 移库明细状态
const YIKUALLSTATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'Shelves.four_px', dm: '下架' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Walking.four_px', dm: '行走' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'Walking.four_px', dm: '行走' }),
    value: 'WP',
  },
];

// 移库列表动作状态
const MOVEKU_ACTION_STATUS = [
  {
    label: $i18n.get({ id: 'Shelves.four_px', dm: '下架' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Walking.four_px', dm: '行走' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'Walking.four_px', dm: '行走' }),
    value: 'WP',
  },
];

// 预约单管理 选择预约单
const YUYUENOTYPE = [
  {
    label: $i18n.get({ id: 'EntrustmentNumber.four_px', dm: '委托单号' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'KHBM.CustomerCode.four_px', dm: '客户编码' }),
    value: '2',
  },

  {
    label: $i18n.get({ id: 'ReservationNumber.four_px', dm: '预约单号' }),
    value: '3',
  },

  {
    label: $i18n.get({ id: 'CustomerOrderNo.four_px', dm: '客户订单号' }),
    value: '4',
  },

  {
    label: $i18n.get({ id: 'CabinetNumber.four_px', dm: '柜号' }),
    value: '5',
  },

  {
    label: $i18n.get({ id: 'BookingDeliveryWarehouseCode.four_px', dm: '预约送仓码' }),
    value: '6',
  },

  {
    label: $i18n.get({ id: 'ReceivingPort.four_px', dm: '收货口' }),
    value: '7',
  },

  {
    label: 'ASNID',
    value: '8',
  },
  {
    label: $i18n.get({ id: 'LogisticsNumber.four_px', dm: '物流单号' }),
    value: '9',
  },
];

// 预约单管理 运输类型
const TRANSPORTYPE = [
  {
    label: $i18n.get({ id: 'AirTransport.four_px', dm: '空运' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'Maritime.four_px', dm: '海运' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'Express.four_px', dm: '快递' }),
    value: 'E',
  },

  {
    label: $i18n.get({ id: 'HighwayTruck.four_px', dm: '公路卡车' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'RailwayTrain.four_px', dm: '铁路火车' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'SelfExtractingInTheDatabase.four_px', dm: '在库自提' }),
    value: 'I',
  },
];

// 预约单管理 运输类型
const TWOTRANSPORTYPE = [
  {
    label: $i18n.get({ id: 'Container.four_px', dm: '集装箱' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Truck.four_px', dm: '卡车' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'Express.four_px', dm: '快递' }),
    value: 'E',
  },
];

// 预约单管理 预约履行状态
const RECEVINGFULFILLSTATUS = [
  {
    label: $i18n.get({ id: 'InAdvance.four_px', dm: '提前' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'OnTime.four_px', dm: '准时' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'Late.four_px', dm: '迟到' }),
    value: 'L',
  },
];

// 预约单管理 承运方式
const CARRIERTYPE = [
  {
    label: $i18n.get({ id: '4pxCarrier.four_px', dm: '4PX承运' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Spontaneous.four_px', dm: '自发' }),
    value: 'M',
  },
];

// 预约单管理 到货确认状态

const ARRIVECONFIRMSTATUS = [
  {
    label: $i18n.get({ id: 'Normal.four_px', dm: '正常' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'Makeup.four_px', dm: '补录' }),
    value: 'M',
  },
  {
    label: $i18n.get({ id: 'NotArrivedInTime', dm: '未及时到仓' }),
    value: 'NA',
  },
];

// 库存对帐
const DIFFERENCE_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'Difference.four_px', dm: '有差异' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'NoDifference.four_px', dm: '无差异' }),
    value: 'N',
  },
];

// 入库订单来源
const INBOUND_SOURELIST = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: 'AE3PL',
    value: 'AE3PL',
  },

  {
    label: 'EWTP',
    value: 'AE4PL',
  },

  {
    label: 'AE4PL',
    value: 'AE4PL2',
  },

  {
    label: $i18n.get({ id: 'NewOpenApi.four_px', dm: '新OPEN-API' }),
    value: 'API',
  },

  {
    label: $i18n.get({ id: 'CainiaoHeadCourse.four_px', dm: '菜鸟头程' }),
    value: 'FIRSTLEG',
  },

  {
    label: 'GFC',
    value: 'GFC',
  },

  {
    label: 'ICBU',
    value: 'ICBU',
  },

  {
    label: 'MF3PL',
    value: 'MF',
  },

  {
    label: 'EF4PL',
    value: 'MF4PL',
  },

  {
    label: 'OPEN-API',
    value: 'OMS',
  },

  {
    label: $i18n.get({ id: 'CainiaoOverseasWarehouse.four_px', dm: '菜鸟海外仓' }),
    value: 'OVERSEA',
  },

  {
    label: 'DS',
    value: 'PT',
  },

  {
    label: $i18n.get({ id: 'QiMen.four_px', dm: '奇门' }),
    value: 'QIMEN',
  },

  {
    label: $i18n.get({ id: 'SuningGermanyWarehouse.four_px', dm: '苏宁德国仓' }),
    value: 'SUNINGDE',
  },

  {
    label: $i18n.get({ id: 'WebsiteOrder.four_px', dm: '网站下单' }),
    value: 'WEB',
  },
];

const BOUNCE_RECEIPT_ORDER = [
  {
    label: $i18n.get({ id: 'ReturnOrderNo.four_px', dm: '退件订单号' }),
    value: 'rtaskNo',
  },

  {
    label: $i18n.get({ id: 'CKDDH.OutboundOrderNo.four_px', dm: '出库订单号' }),
    value: 'consignmentNo',
  },

  {
    label: $i18n.get({ id: 'ServiceProviderId.four_px', dm: '服务商单号' }),
    value: 'shippingNo',
  },

  {
    label: $i18n.get({ id: 'OrderNo.four_px', dm: '退件收货作业单号' }),
    value: 'jobNo',
  },
];

const BOUNCE_RECEIPT_TIME = [
  {
    label: $i18n.get({ id: 'StartTime.four_px', dm: '开始时间' }),
    value: 'beginTime',
  },

  {
    label: $i18n.get({ id: 'EndTime.four_px', dm: '结束时间' }),
    value: 'endTime',
  },
];

const BOUNCE_RECEIPT_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'NotStarted.four_px', dm: '未开始' }),
    value: 'UN_START',
  },

  {
    label: $i18n.get({ id: 'InProgress.four_px', dm: '进行中' }),
    value: 'PROCESSING',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'FINISHED',
  },
];

const BOUNCE_QUALITY_STATUS = [
  {
    label: $i18n.get({ id: 'Good.four_px', dm: '良好' }),
    value: 'GOOD',
  },

  {
    label: $i18n.get({ id: 'Damaged.four_px', dm: '破损' }),
    value: 'BAD',
  },
];

/**
 * 退件上架订单
 */
const BOUNCE_PUTAWAY_ORDER = [
  {
    label: $i18n.get({ id: 'ReturnOrderNo.four_px', dm: '退件订单号' }),
    value: 'rtaskNo',
  },

  {
    label: $i18n.get({ id: 'CKDDH.OutboundOrderNo.four_px', dm: '出库订单号' }),
    value: 'consignmentNo',
  },

  {
    label: $i18n.get({ id: 'ServiceProviderId.four_px', dm: '服务商单号' }),
    value: 'shippingNo',
  },

  {
    label: $i18n.get({ id: 'ReturnAndShelvingWorkOrderNo.four_px', dm: '退件上架作业单号' }),
    value: 'jobNo',
  },
];

/**
 * 退件上架时间
 */
const BOUNCE_PUTAWAY_TIME = [
  {
    label: $i18n.get({ id: 'StartTime.four_px', dm: '开始时间' }),
    value: 'beginTime',
  },

  {
    label: $i18n.get({ id: 'EndTime.four_px', dm: '结束时间' }),
    value: 'endTime',
  },
];

/**
 * 退件上架状态
 */
const BOUNCE_PUTAWAY_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'NotStarted.four_px', dm: '未开始' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'InProgress.four_px', dm: '进行中' }),
    value: 'I',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'C',
  },
];

/**
 * 退件上架类型
 */
const BOUNCE_PUTAWAY_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'Walking.four_px', dm: '行走' }),
    value: 'XZ',
  },

  {
    label: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: 'PT',
  },

  {
    label: $i18n.get({ id: 'XYGSKU.NextSku.four_px', dm: '下一个SKU' }),
    value: 'NS',
  },

  {
    label: $i18n.get({ id: 'Complete.four_px', dm: '完成' }),
    value: 'CM',
  },

  {
    label: $i18n.get({ id: 'SkuShelving.four_px', dm: 'SKU上架' }),
    value: 'TS',
  },

  {
    label: $i18n.get({ id: 'ContainerShelving.four_px', dm: '容器上架' }),
    value: 'TC',
  },
];

/**
 * 退件订单详情订单类别
 */
const BOUNCE_PUTAWAY_DETAIL_ORDER = [
  {
    label: $i18n.get({ id: 'ReturnOrderNo.four_px', dm: '退件订单号' }),
    value: 'rtaskNo',
  },

  {
    label: $i18n.get({ id: 'CKDDH.OutboundOrderNo.four_px', dm: '出库订单号' }),
    value: 'consignmentNo',
  },

  {
    label: $i18n.get({ id: 'ServiceProviderId.four_px', dm: '服务商单号' }),
    value: 'shippingNo',
  },

  // {
  //   label: $i18n.get({ id: 'GrsOrderNo.four_px', dm: 'GRS订单号' }),
  //   value: '',
  // },
  {
    label: $i18n.get({ id: 'ReturnAndShelvingWorkOrderNo.four_px', dm: '退件上架作业单号' }),
    value: 'jobNo',
  },
];

/**
 * 退件上架异常订单类别
 */
const BOUNCE_PUTAWAY_ABNOR_ORDER = [
  {
    label: $i18n.get({ id: 'ReturnOrderNo.four_px', dm: '退件订单号' }),
    value: 'rtaskNo',
  },

  {
    label: $i18n.get({ id: 'CKDDH.OutboundOrderNo.four_px', dm: '出库订单号' }),
    value: 'consignmentNo',
  },

  {
    label: $i18n.get({ id: 'ServiceProviderId.four_px', dm: '服务商单号' }),
    value: 'shippingNo',
  },

  // {
  //   label: $i18n.get({ id: 'GrsOrderNo.four_px', dm: 'GRS订单号' }),
  //   value: '',
  // },
  {
    label: $i18n.get({ id: 'ReturnAndShelvingWorkOrderNo.four_px', dm: '退件上架作业单号' }),
    value: 'jobNo',
  },

  // {
  //   label: $i18n.get({ id: 'TurnoverBoxNumber.four_px', dm: '周转箱号' }),
  //   value: 'containerNo',
  // },
];

/**
 * 退件操作步骤
 */
const BOUNCE_OPERATE_STEP = [
  {
    label: $i18n.get({ id: 'ShelvingScanningTurnoverBox.four_px', dm: '上架扫描周转箱' }),
    value: 'RP0001',
  },

  {
    label: $i18n.get({ id: 'SJSMSKU.ShelvingScanningSku.four_px', dm: '上架扫描SKU' }),
    value: 'RP0002',
  },

  {
    label: $i18n.get({ id: 'ShelvingScanLocation.four_px', dm: '上架扫描库位' }),
    value: 'RP0003',
  },

  {
    label: $i18n.get({ id: 'ShelvingSubmission.four_px', dm: '上架提交' }),
    value: 'RP0004',
  },

  {
    label: $i18n.get({ id: 'ScanNumber.four_px', dm: '扫描单号' }),
    value: 'RR0001',
  },

  {
    label: $i18n.get({ id: 'ScanSku.four_px', dm: '扫描SKU' }),
    value: 'RR0002',
  },

  {
    label: $i18n.get({ id: 'Submitted.four_px', dm: '提交' }),
    value: 'RR0003',
  },

  {
    label: $i18n.get({ id: 'OutOfStockDetails.four_px', dm: '缺货详情' }),
    value: 'RP0005',
  },

  {
    label: $i18n.get({ id: 'OutOfStockSubmission.four_px', dm: '缺货提交' }),
    value: 'RP0006',
  },
];

const IBOUND_OPERATE_CONTENT = [
  {
    label: $i18n.get({ id: 'ScanInboundOrderNumberBoxNumber.four_px', dm: '扫描入库订单号/箱唛号' }),
    value: 'U0001',
  },

  {
    label: $i18n.get({ id: 'UnloadingSubmission.four_px', dm: '卸货提交' }),
    value: 'U0002',
  },

  {
    label: $i18n.get({ id: 'ExceptionHandling.four_px', dm: '异常处理' }),
    value: 'U0003',
  },

  {
    label: $i18n.get({ id: 'ScanInboundOrderNumberBoxNumber.four_px', dm: '扫描入库订单号/箱唛号' }),
    value: 'R0001',
  },

  {
    label: $i18n.get({ id: 'TurnoverBox.four_px', dm: '扫周转箱' }),
    value: 'R0002',
  },

  {
    label: $i18n.get({ id: 'SSKUBM.ScanSkuCode.four_px', dm: '扫SKU编码' }),
    value: 'R0003',
  },

  {
    label: $i18n.get({ id: 'SkuCheck.four_px', dm: 'SKU查验' }),
    value: 'R0004',
  },

  {
    label: $i18n.get({ id: 'ContainerReceiptSubmission.four_px', dm: '容器收货提交' }),
    value: 'R0005',
  },

  {
    label: $i18n.get({ id: 'SubmitByOrder.four_px', dm: '按单收货提交' }),
    value: 'R0006',
  },

  {
    label: $i18n.get({ id: 'ScanContainer.four_px', dm: '扫描容器' }),
    value: 'P0001',
  },

  {
    label: $i18n.get({ id: 'SubmitContainerShelving.four_px', dm: '提交容器上架' }),
    value: 'P0002',
  },

  {
    label: $i18n.get({ id: 'ScanInboundOrderNumberBoxNumber.four_px', dm: '扫描入库订单号/箱唛号' }),
    value: 'P0003',
  },

  {
    label: $i18n.get({ id: 'ScanSkuCode.four_px', dm: '扫描SKU编码' }),
    value: 'P0004',
  },

  {
    label: $i18n.get({ id: 'SubmitSkuForShelving.four_px', dm: '提交SKU上架' }),
    value: 'P0005',
  },

  {
    label: $i18n.get({ id: 'ExceptionHandling.four_px', dm: '异常处理' }),
    value: 'P0006',
  },

  {
    label: $i18n.get({ id: 'ForcedEnd.four_px', dm: '强制完结' }),
    value: 'R0007',
  },

  {
    label: $i18n.get({ id: 'ForcedEnd.four_px', dm: '强制完结' }),
    value: 'P0007',
  },

  {
    label: $i18n.get({ id: 'ForcedEnd.four_px', dm: '强制完结' }),
    value: 'U0004',
  },

  {
    label: $i18n.get({ id: 'ChangeWarehouse.four_px', dm: '改仓' }),
    value: 'U0008',
  },

  {
    label: $i18n.get({ id: 'ChangeWarehouse.four_px', dm: '改仓' }),
    value: 'R0008',
  },

  {
    label: $i18n.get({ id: 'ChangeWarehouse.four_px', dm: '改仓' }),
    value: 'P0008',
  },
  {
    label: $i18n.get({ id: 'TitReportConfirmation', dm: '理货报告确认' }),
    value: 'R0010',
  },
  {
    label: $i18n.get({ id: 'TitReportRejected', dm: '理货报告驳回' }),
    value: 'R0011',
  },
  {
    label: $i18n.get({ id: 'TitReportSubmission', dm: '理货报告提交' }),
    value: 'R0012',
  },
  {
    label: $i18n.get({ id: 'ContainersContinueToReceive', dm: '容器继续收货' }),
    value: 'R0013',
  },
  {
    label: $i18n.get({ id: 'EmptyReceipt', dm: '清空收货' }),
    value: 'R0014',
  },
  {
    label: $i18n.get({ id: 'CompleteReceipt', dm: '完成收货' }),
    value: 'R0015',
  },

  {
    label: $i18n.get({ id: 'ModifyReceivingQuantity', dm: '修改收货数量' }),
    value: 'R0016',
  },
  {
    label: $i18n.get({ id: 'ExceptionHandling.four_px', dm: '异常处理' }),
    value: 'P00010',
  },
  {
    label: $i18n.get({ id: 'ContainerReceiptSubmission.four_px', dm: '容器收货提交' }),
    value: 'R0009',
  },
  {
    label: $i18n.get({ id: 'ShelfVAS', dm: '上架-VAS' }),
    value: 'P0009',
  },
];

/**
 * 收货 - 商品异常tab
 */
const RECEIPT_GOODS_TAB = [
  {
    label: $i18n.get({ id: 'ToBeSubmitted', dm: '待提交' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'Pending.four_px', dm: '待处理' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'ToBeReviewed.four_px', dm: '待复核' }),
    value: 'V',
  },

  {
    label: $i18n.get({ id: 'PendingConfirmation.four_px', dm: '待确认' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'Procosed', dm: '已处理' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Closed.four_px', dm: '已完结' }),
    value: 'F',
  },
];

/**
 * 商品异常报表
 */
/**
 * 异常状态
 */
const GOOD_ABNOR_STATUS = [
  {
    label: $i18n.get({ id: 'PendingCustomerProcessing.four_px', dm: '待客户处理' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'ToBeReviewed.four_px', dm: '待复核' }),
    value: 'V',
  },

  {
    label: $i18n.get({ id: 'PendingCustomerConfirmation.four_px', dm: '待客户确认' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'Closed.four_px', dm: '已完结' }),
    value: 'F',
  },
];

/**
 * 异常大类
 */
const GOOD_ABNORMAL_CATEGORIES = [
  {
    label: $i18n.get({ id: 'SizeWeightDoesNotMatch.four_px', dm: '尺寸重量不符' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'AbnormalQuality', dm: '质量异常' }),
    value: 'E01',
  },

  {
    label: $i18n.get({ id: 'Exceptions', dm: '多货异常' }),
    value: 'E02',
  },

  {
    label: $i18n.get({ id: 'MultiproductAbnormality', dm: '多品异常' }),
    value: 'E03',
  },

  {
    label: $i18n.get({ id: 'BarcodeMissingException', dm: '条码缺失异常' }),
    value: 'E04',
  },

  {
    label: $i18n.get({ id: 'AbnormalGoods', dm: '少货异常' }),
    value: 'E05',
  },

  {
    label: $i18n.get({ id: 'AbnormalValidityPeriod', dm: '效期异常' }),
    value: 'E07',
  },
];

/**
 * 异常类型
 */
const GOOD_ABNOR_TYPE = {
  D: [
    {
      label: $i18n.get({ id: 'SizeWeightDoesNotMatch.four_px', dm: '尺寸重量不符' }),
      value: 'skuMaterialException',
    },
  ],

  E01: [
    {
      label: $i18n.get({ id: 'BrokenPackagingcontaminatedGoods', dm: '外包装破损/商品受污染' }),
      value: 'E01-01',
    },

    {
      label: $i18n.get({ id: 'PartsSeparation', dm: '零配件分离' }),
      value: 'E01-02',
    },
  ],

  E02: [
    {
      label: $i18n.get({ id: 'ArrivalNumberExceedsForecast', dm: '到货件数超预报' }),
      value: 'E02-01',
    },

    {
      label: $i18n.get({ id: 'IndefiniteStorageSpecifications', dm: '入库规格不确定' }),
      value: 'E02-02',
    },
  ],

  E03: [
    {
      label: $i18n.get({ id: 'NoForecastCommodities', dm: '无预报商品' }),
      value: 'E03-01',
    },
  ],

  E04: [
    {
      label: $i18n.get({ id: 'NoBarCode', dm: '无条码' }),
      value: 'E04-01',
    },

    {
      label: $i18n.get({ id: 'BarcodeIsNotReadable', dm: '条码不可读' }),
      value: 'E04-02',
    },

    {
      label: $i18n.get({ id: 'TheBarcodeCannotBeMappedToTheCus_1410754691', dm: '条码无法映射该客户的SKU' }),
      value: 'E04-03',
    },
  ],

  E05: [
    {
      label: $i18n.get({ id: 'GoodsLessThanBoxGaugeQuantity', dm: '商品少于箱规数量' }),
      value: 'E05-01',
    },

    {
      label: $i18n.get({ id: 'NoPhysicalObjectsInTheBox', dm: '包装盒内无实物' }),
      value: 'E05-02',
    },
    {
      label: $i18n.get({ id: 'LessDeliveryOfTheWholeContainer', dm: '整箱少到货' }),
      value: 'E05-04',
    },
  ],

  E07: [
    {
      label: $i18n.get({ id: 'TheExpirationDateIsUnreadable', dm: '效期不可读' }),
      value: 'E07-01',
    },
  ],

  // 兼容详情页展示异常类型
  skuMaterialException: [
    {
      label: $i18n.get({ id: 'SizeWeightDoesNotMatch.four_px', dm: '尺寸重量不符' }),
      value: 'skuMaterialException',
    },
  ],
};

/**
 * 处理意见
 */
const DEAL_OPINION_CATEGORIES = [
  {
    label: $i18n.get({ id: 'Destruction.four_px', dm: '销毁' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'Repackaging.four_px', dm: '重新包装' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'AccordingToThePhysicalShelves', dm: '按实物上架' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'QRCY.ConfirmTheDifference.four_px', dm: '确认差异' }),
    value: 'B',
  },

  {
    label: $i18n.get({ id: 'DeliveredInBatches.four_px', dm: '分批到货' }),
    value: 'FP',
  },

  {
    label: $i18n.get({ id: 'DifferenceCompensationAndWarehou_1224642028', dm: '补差入库' }),
    value: 'BC',
  },

  {
    label: $i18n.get({ id: 'TagProcessing.four_px', dm: '标签处理' }),
    value: 'LP',
  },

  {
    label: $i18n.get({ id: 'AssociatedBarcode', dm: '关联条码' }),
    value: 'AB',
  },

  {
    label: $i18n.get({ id: 'RereadingOfValidityPeriod', dm: '效期重读' }),
    value: 'ER',
  },
];

/**
 * 日志部门
 */
const LOG_DEPARTMENT = [
  {
    label: $i18n.get({ id: 'Warehouse.four_px', dm: '仓库' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'CustomerService.four_px', dm: '客服' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'Customer.four_px', dm: '客户' }),
    value: 'C',
  },
];

/**
 * 处理日志备注
 */
const LOG_REMARK = [
  {
    label: $i18n.get({ id: 'SkuException.four_px', dm: 'sku异常' }),
    value: 'sku exception',
  },

  {
    label: $i18n.get({ id: 'InitiateAChallenge.four_px', dm: '发起挑战' }),
    value: 'fb4.check.excepetion.chal',
  },

  {
    label: $i18n.get({ id: 'SystemUpdateSku.four_px', dm: '系统更新sku' }),
    value: 'fb4.check.skuUpdate.sys',
  },

  {
    label: $i18n.get({ id: 'VerifyAndUpdateSkuInThe_1005732612.four_px', dm: '库内核实更新sku' }),
    value: 'fb4.check.skuUpdate.warehouse',
  },

  {
    label: $i18n.get({ id: 'QRCY.ConfirmTheDifference.four_px', dm: '确认差异' }),
    value: 'fb4.check.excepetion.conf',
  },

  {
    label: $i18n.get({ id: 'Repackaging.four_px', dm: '重新包装' }),
    value: 'fb4.check.exception.repackage',
  },

  {
    label: $i18n.get({ id: 'AccordingToThePhysicalShelves', dm: '按实物上架' }),
    value: 'fb4.check.exception.stock.base.actual',
  },

  {
    label: $i18n.get({ id: 'BatchToWarehouse', dm: '分批到仓' }),
    value: 'fb4.check.exception.delivered.in.batches',
  },

  {
    label: $i18n.get({ id: 'DifferenceCompensationAndWarehou_1224642028', dm: '补差入库' }),
    value: 'fb4.check.exception.replenish.diff',
  },

  {
    label: $i18n.get({ id: 'TagProcessing.four_px', dm: '标签处理' }),
    value: 'fb4.check.exception.label.processing',
  },

  {
    label: $i18n.get({ id: 'AssociationSynchronization', dm: '关联同步' }),
    value: 'fb4.check.exception.associated.barcode',
  },

  {
    label: $i18n.get({ id: 'RereadingOfValidityPeriod', dm: '效期重读' }),
    value: 'fb4.check.exception.expiry.date.recheck',
  },

  {
    label: $i18n.get({ id: 'BrokenPackagingcontaminatedGoods', dm: '外包装破损/商品受污染' }),
    value: 'fb4.check.exception.packaging.damaged',
  },

  {
    label: $i18n.get({ id: 'PartsSeparation', dm: '零配件分离' }),
    value: 'fb4.check.exception.accessories.separated',
  },

  {
    label: $i18n.get({ id: 'ArrivalNumberExceedsForecast', dm: '到货件数超预报' }),
    value: 'fb4.check.exception.over.stock.exceeds',
  },

  {
    label: $i18n.get({ id: 'NoForecastCommodities', dm: '无预报商品' }),
    value: 'fb4.check.exception.no.forecast',
  },

  {
    label: $i18n.get({ id: 'NoBarCode', dm: '无条码' }),
    value: 'fb4.check.exception.barcode.missing',
  },

  {
    label: $i18n.get({ id: 'BarcodeIsNotReadable', dm: '条码不可读' }),
    value: 'fb4.check.exception.barcode.unreadable',
  },

  {
    label: $i18n.get({ id: 'TheBarcodeCannotBeMappedToTheCus_1410754691', dm: '条码无法映射该客户的SKU' }),
    value: 'fb4.check.exception.sku.unmapping',
  },

  {
    label: $i18n.get({ id: 'GoodsLessThanBoxGaugeQuantity', dm: '商品少于箱规数量' }),
    value: 'fb4.check.exception.quantity.less.than.pack',
  },

  {
    label: $i18n.get({ id: 'NoPhysicalObjectsInTheBox', dm: '包装盒内无实物' }),
    value: 'fb4.check.exception.no.goods',
  },

  {
    label: $i18n.get({ id: 'TheExpirationDateIsUnreadable', dm: '效期不可读' }),
    value: 'fb4.check.exception.expiry.date.unreadable',
  },
  {
    label: $i18n.get({ id: 'LessDeliveryOfTheWholeContainer', dm: '整箱少到货' }),
    value: 'fb4.check.exception.less.goods',
  },
  {
    label: $i18n.get({ id: 'ImmediatelyCertified', dm: '立即认证' }),
    value: 'fb4.check.excepetion.auth',
  },

  {
    label: $i18n.get({ id: 'SupplementaryInformation', dm: '补充资料' }),
    value: 'fb4.check.excepetion.supp',
  },

  {
    label: $i18n.get({ id: 'ReturnOfGoods', dm: '退回货物' }),
    value: 'fb4.check.excepetion.retu',
  },

  {
    lable: $i18n.get({ id: 'ValueAddedServices.four_px', dm: '增值服务' }),
    value: 'fb4.check.excepetion.incr',
  },

  {
    label: $i18n.get({ id: 'AccordingToThePhysicalGoods', dm: '按实物走货' }),
    value: 'fb4.check.excepetion.actu',
  },

  {
    label: $i18n.get({ id: 'Destruction.four_px', dm: '销毁' }),
    value: 'fb4.check.excepetion.dest',
  },

  {
    label: $i18n.get({ id: 'InitiateAChallenge.four_px', dm: '发起挑战' }),
    value: 'fb4.check.excepetion.chal',
  },

  {
    label: $i18n.get({ id: 'QRCY.ConfirmTheDifference.four_px', dm: '确认差异' }),
    value: 'fb4.check.excepetion.conf',
  },

  {
    label: $i18n.get({ id: 'ApplyForRetest', dm: '申请重测' }),
    value: 'fb4.check.excepetion.retest',
  },

  {
    label: $i18n.get({ id: 'Closed.four_px', dm: '已完结' }),
    value: 'fb4.check.exception.warehouse.finished',
  },

  {
    label: $i18n.get({ id: 'AutomaticCompletion', dm: '自动完结' }),
    value: 'fb4.auto.finish',
  },
  {
    label: $i18n.get({ id: 'AuditCompleted', dm: '审核完结' }),
    value: 'fb4.check.skuAudit.completed',
  },
  {
    label: $i18n.get({ id: 'InitiateAReview', dm: '发起复核' }),
    value: 'fb4.check.initiate.review',
  },
  {
    label: $i18n.get({ id: 'ManualCompletion', dm: '手动完结' }),
    value: 'fb4.manual.completion',
  },
];

const DEAL_SUGGESTION = [
  {
    label: $i18n.get({ id: 'InitiateAChallenge.four_px', dm: '发起挑战' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'ReviewAgain.four_px', dm: '再次复核' }),
    value: 'V',
  },

  {
    label: $i18n.get({ id: 'QRCY.ConfirmTheDifference.four_px', dm: '确认差异' }),
    value: 'B',
  },
];

const LOGISTICS_PACKAGING = [
  {
    label: $i18n.get({ id: 'SelfContainedLogisticsPackaging.four_px', dm: '自带物流包装' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'NonSelfContainedPackaging.four_px', dm: '非自带包装' }),
    value: 'N',
  },
];

// 预约状态s
const YUYUESTATUS = [
  {
    value: 'S',
    label: $i18n.get({ id: 'DeliveryAppointment.four_px', dm: '收货预约' }),
  },

  {
    value: 'V',
    label: $i18n.get({ id: 'ValueAddedReservation.four_px', dm: '增值预约' }),
  },

  {
    value: 'W',
    label: $i18n.get({ id: 'ArrangementReservation.four_px', dm: '排仓预约' }),
  },

  {
    value: 'R',
    label: $i18n.get({ id: 'QueueForAppointment.four_px', dm: '排队预约' }),
  },

  {
    value: 'A',
    label: $i18n.get({ id: 'AutomaticReservation.four_px', dm: '自动预约' }),
  },
];

// 业务类型

const BUSINESSTYPEPRODULE = [
  {
    label: $i18n.get({ id: 'StandardOutbound.four_px', dm: '标准出库' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'StorageAndShelving.four_px', dm: '入库上架' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'InventoryAdjustment.four_px', dm: '库存调整' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'Transit.four_px', dm: '移库' }),
    value: 'M',
  },

  {
    label: $i18n.get({ id: 'ReturnAndReceive.four_px', dm: '退件收货' }),
    value: 'GV',
  },

  {
    label: $i18n.get({ id: 'ReturnUpperShelf.four_px', dm: '退件上架' }),
    value: 'GP',
  },

  {
    label: $i18n.get({ id: 'ValueAddedServices.four_px', dm: '增值服务' }),
    value: 'V',
  },
];

const GOODSABNOR_YES_NO = [
  {
    label: $i18n.get({ id: 'Is.four_px', dm: '是' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'F.No.four_px', dm: '否' }),
    value: 'N',
  },
];

// 收货路径
const RECEIVE_PATH = [
  {
    label: $i18n.get({ id: 'OpsReceive.four_px', dm: 'OPS收货' }),
    value: 'OPS',
  },

  {
    label: $i18n.get({ id: 'PdaReceive.four_px', dm: 'PDA收货' }),
    value: 'PDA',
  },
];

const REPORT_LIST = [
  {
    label: $i18n.get({ id: 'FailedToMatch.four_px', dm: '匹配失败' }),
    value: 'MF',
  },

  {
    label: $i18n.get({ id: 'ChangedNumberFailed.four_px', dm: '换号失败' }),
    value: 'CE',
  },
  {
    label: $i18n.get({ id: 'OutboundException.four_px', dm: '出库异常' }),
    value: 'E',
  },
  {
    label: $i18n.get({ id: 'ToBeIntercepted', dm: '待拦截' }),
    value: 'PI',
  },
  {
    label: $i18n.get({ id: 'Reviewed.four_px', dm: '已审核' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'PendingOrder.four_px', dm: '待汇单' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'RemittanceInProgress.four_px', dm: '汇单中' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'OrdersReceived.four_px', dm: '已汇单' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'JHZ.Picking.four_px', dm: '拣货中' }),
    value: 'I',
  },

  {
    label: $i18n.get({ id: 'PickedUp.four_px', dm: '已拣货' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'SortingInProgress.four_px', dm: '分拣中' }),
    value: 'Q',
  },

  {
    label: $i18n.get({ id: 'Sorted.four_px', dm: '已分拣' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'Packaging.four_px', dm: '打包中' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'LogisticsSingleCollection', dm: '物流单采集' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: 'Packaged.four_px', dm: '已打包' }),
    value: 'K',
  },

  {
    label: $i18n.get({ id: 'Summary.four_px', dm: '汇总' }),
    value: 'HZ',
  },
];

const EATIMES = [
  {
    value: 'E',
    label: $i18n.get({ id: 'EstimatedOutboundTime.four_px', dm: '预计出库时间' }),
  },

  {
    label: $i18n.get({ id: 'ReviewTime.four_px', dm: '审核时间' }),
    value: 'A',
  },
];

const PACKJOBSTATUS = [
  {
    value: 'W',
    label: $i18n.get({ id: 'ToBePackaged.four_px', dm: '待打包' }),
  },

  {
    value: 'P',
    label: $i18n.get({ id: 'InProgress.four_px', dm: '进行中' }),
  },

  {
    value: 'C',
    label: $i18n.get({ id: 'DBWC.Packaged.four_px', dm: '打包完成' }),
  },

  {
    value: 'F',
    label: $i18n.get({ id: 'PackagingFailed.four_px', dm: '打包失败' }),
  },
];

const BUSINESSTYPES = [
  {
    label: $i18n.get({ id: 'InventoryAdjustment.four_px', dm: '库存调整' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'OrderCancellationReUpperShelf.four_px', dm: '订单取消重新上架' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Destruction.four_px', dm: '销毁' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'DropshippingOutboundOrder.four_px', dm: 'DropShipping出库委托单' }),
    value: 'DS',
  },

  {
    label: $i18n.get({ id: 'FbaProCheckedOut.four_px', dm: 'FBA Pro出库' }),
    value: 'FBA',
  },

  {
    label: $i18n.get({ id: 'GrsReturned.four_px', dm: 'GRS退件' }),
    value: 'GRSP',
  },

  {
    label: $i18n.get({ id: 'OtherOrders.four_px', dm: '其他委托单' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'ReceiptUpperShelf.four_px', dm: '收货上架' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'ReturnOrder.four_px', dm: '退仓委托单' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'StandardPowerOfAttorney.four_px', dm: '标准委托单' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'ServiceProviderReturn.four_px', dm: '服务商退件' }),
    value: 'SR',
  },

  {
    label: $i18n.get({ id: 'TransferOrder.four_px', dm: '调拨委托单' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'InternalTransferOrder.four_px', dm: '内部调拨单' }),
    value: 'TT',
  },

  {
    label: $i18n.get({ id: 'ManualInventoryAdjustment.four_px', dm: '手工库存调整' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: 'ReturnAndReceive.four_px', dm: '退件收货' }),
    value: 'GV',
  },

  {
    label: $i18n.get({ id: 'ReturnUpperShelf.four_px', dm: '退件上架' }),
    value: 'GP',
  },

  {
    label: $i18n.get({ id: 'Transit.four_px', dm: '移库' }),
    value: 'M',
  },
];

const ASSORTJOBSTATUS_LIST = [
  {
    label: $i18n.get({ id: 'Idle.four_px', dm: '空闲' }),
    value: 'IDLE',
  },

  {
    label: $i18n.get({ id: 'SortingInProgress.four_px', dm: '分拣中' }),
    value: 'ASSORTING',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'FINISHED',
  },

  {
    label: $i18n.get({ id: 'QH.OutOfStock.four_px', dm: '缺货' }),
    value: 'STOCK_OUT',
  },
];

// 电池特性
const ISBATTERYS = [
  {
    label: $i18n.get({ id: 'DD.Charged.four_px', dm: '带电' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'NotCharged.four_px', dm: '不带电' }),
    value: 'N',
  },
];

// 卸货类型 unloadType
const UNLOADTYPES = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'CountTheNumberOfBoxes.four_px', dm: '清点箱数' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'BoxByBoxUnloading.four_px', dm: '逐箱卸货' }),
    value: 'B',
  },
];

/**
 * 入库重推
 */
// 事件编码
const EVENT_CODES = [
  {
    label: $i18n.get({ id: 'ReturnUnloadingInformation.four_px', dm: '卸货信息回传' }),
    value: 4100,
  },

  {
    label: $i18n.get({ id: 'ReturnReceiptInformation.four_px', dm: '收货信息回传' }),
    value: 4200,
  },

  {
    label: $i18n.get({ id: 'UploadShelvingInformation.four_px', dm: '上架信息回传' }),
    value: 4300,
  },

  {
    label: $i18n.get({ id: 'ReturnAliexpressEfUnloadingInformation.four_px', dm: 'AE/EF卸货信息回传' }),
    value: 11000,
  },

  {
    label: $i18n.get({ id: 'AeEfReceiptInformation.four_px', dm: 'AE/EF收货信息回传' }),
    value: 12000,
  },

  {
    label: $i18n.get({ id: 'SendBackTheReceiptSkuInformation_3198319265.four_px', dm: 'AE收货SKU信息回传' }),
    value: 12100,
  },

  {
    label: $i18n.get({ id: 'SendBackTheInformationOfAe_4025673421.four_px', dm: 'AE/EF上架中信息回传' }),
    value: 13000,
  },

  {
    label: $i18n.get({ id: 'SendBackTheAliexpressShelvingCompletion_2910031769.four_px', dm: 'AE上架完成信息回传' }),
    value: 13100,
  },

  {
    label: $i18n.get({ id: 'AeEfWarehousingEntrustmentCompleted.four_px', dm: 'AE/EF入库委托单完结' }),
    value: 14000,
  },

  {
    label: $i18n.get({ id: 'ExceptionReportReturn', dm: '异常提报回传' }),
    value: 14100,
  },

  {
    label: $i18n.get({ id: 'EfSynchronousArrivalConfirmation.four_px', dm: 'EF同步到货确认' }),
    value: 15000,
  },

  {
    label: $i18n.get({ id: 'EfBatchUnloadingCompleted.four_px', dm: 'EF批次卸货完结' }),
    value: 16000,
  },
];

// 收货异常页面
const RECEIPT_ANBOR_TAB = [
  {
    label: $i18n.get({ id: 'ReceiptVariance', dm: '收货差异' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'UnhandledExceptions.four_px', dm: '异常待处理' }),
    value: 'B',
  },
];

// 理货报告状态
const INBOUND_TALLY_STATUS = [
  {
    label: $i18n.get({ id: 'ToBeSubmitted', dm: '待提交' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'PendingReview.four_px', dm: '待审核' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'Confirmed.four_px', dm: '已确认' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Rejected.YObEl', dm: '已驳回' }),
    value: 'R',
  },
];

// 理货报告状态
const TALLY_STATUS = [
  {
    label: $i18n.get({ id: 'ToBeSubmitted', dm: '待提交' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'PendingReview.four_px', dm: '待审核' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'Confirmed.four_px', dm: '已确认' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Rejected.YObEl', dm: '已驳回' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'Closed', dm: '已关闭' }),
    value: 'F',
  },
];

// 异常收货异常
const TALLY_EXCEPTION_TYPE = [
  {
    label: $i18n.get({ id: 'AbnormalQuality', dm: '质量异常' }),
    value: 'E01',
  },

  {
    label: $i18n.get({ id: 'Exceptions', dm: '多货异常' }),
    value: 'E02',
  },

  {
    label: $i18n.get({ id: 'MultiproductAbnormality', dm: '多品异常' }),
    value: 'E03',
  },

  {
    label: $i18n.get({ id: 'BarcodeMissingException', dm: '条码缺失异常' }),
    value: 'E04',
  },

  {
    label: $i18n.get({ id: 'AbnormalGoods', dm: '少货异常' }),
    value: 'E05',
  },
  {
    label: $i18n.get({ id: 'SalesUnitUncertain', dm: '销售单元不确定' }),
    value: 'E06',
  },
  {
    label: $i18n.get({ id: 'AbnormalValidityPeriod', dm: '效期异常' }),
    value: 'E07',
  },
  {
    label: $i18n.get({ id: 'AbnormalBoxMark', dm: '箱唛异常' }),
    value: 'E08',
  },
  {
    label: $i18n.get({ id: 'TheClosedOrderNeedsToBePutOn', dm: '已关单需上架' }),
    value: 'E09',
  },
];

// 异常收货子异常
const TALLY_SUBEXCEPTION_TYPE = {
  E01: [
    {
      label: $i18n.get({ id: 'BrokenPackagingcontaminatedGoods', dm: '外包装破损/商品受污染' }),
      value: 'E01-01',
    },

    {
      label: $i18n.get({ id: 'PartsSeparation', dm: '零配件分离' }),
      value: 'E01-02',
    },
  ],

  E02: [
    {
      label: $i18n.get({ id: 'ArrivalNumberExceedsForecast', dm: '到货件数超预报' }),
      value: 'E02-01',
    },
  ],

  E03: [
    {
      label: $i18n.get({ id: 'NoForecastCommodities', dm: '无预报商品' }),
      value: 'E03-01',
    },
  ],

  E04: [
    {
      label: $i18n.get({ id: 'NoBarCode', dm: '无条码' }),
      value: 'E04-01',
    },

    {
      label: $i18n.get({ id: 'BarcodeIsNotReadable', dm: '条码不可读' }),
      value: 'E04-02',
    },

    {
      label: $i18n.get({ id: 'TheBarcodeCannotBeMappedToTheCus_1410754691', dm: '条码无法映射该客户的SKU' }),
      value: 'E04-03',
    },
  ],

  E05: [
    {
      label: $i18n.get({ id: 'GoodsLessThanBoxGaugeQuantity', dm: '商品少于箱规数量' }),
      value: 'E05-01',
    },

    {
      label: $i18n.get({ id: 'NoPhysicalObjectsInTheBox', dm: '包装盒内无实物' }),
      value: 'E05-02',
    },
  ],

  E06: [
    {
      label: $i18n.get({ id: 'TheBarcodeOfInnerAndOuterBoxIs', dm: '内外箱条码一致' }),
      value: 'E06-01',
    },
    {
      label: $i18n.get({ id: 'IndefiniteStorageSpecifications', dm: '入库规格不确定' }),
      value: 'E06-02',
    },
  ],

  E07: [
    {
      label: $i18n.get({ id: 'Forbidden', dm: '禁收' }),
      value: 'E07-01',
    },
    {
      label: $i18n.get({ id: 'Prohibited', dm: '禁售' }),
      value: 'E07-02',
    },
    {
      label: $i18n.get({ id: 'ProductionDateUpsideDown', dm: '生产日期倒挂' }),
      value: 'E07-03',
    },
  ],

  E08: [
    {
      label: $i18n.get({ id: 'MissingOrUnrecognizedContainerMa_1651126202', dm: '箱唛缺失或无法识别' }),
      value: 'E08-01',
    },
  ],

  E09: [
    {
      label: $i18n.get({ id: 'TheClosedOrderNeedsToBePutOn', dm: '已关单需上架' }),
      value: 'E09-01',
    },
  ],
};

// 处理方式
const TALLY_EXCEPTION_DEAL_TYPE = [
  {
    label: $i18n.get({ id: 'confirm', dm: '确认' }),
    value: 'CONFIRM',
  },
  {
    label: $i18n.get({ id: 'SecondaryTally', dm: '二次理货' }),
    value: 'SECOND_TALLY',
  },
  {
    label: $i18n.get({ id: 'DifferenceCompensationAndWarehou_1224642028', dm: '补差入库' }),
    value: 'MAKE_UP',
  },
  {
    label: $i18n.get({ id: 'Disposal', dm: '弃置' }),
    value: 'DISCARD',
  },
  {
    label: $i18n.get({ id: 'Retrieve', dm: '取回' }),
    value: 'RETRIEVE',
  },
  {
    label: $i18n.get({ id: 'ShelfByRemnants', dm: '按残品上架' }),
    value: 'DEFECTIVE_ON_SHELVES',
  },
  {
    label: $i18n.get({ id: 'Reorganization', dm: '重组' }),
    value: 'REORGANIZE',
  },
  {
    label: $i18n.get({ id: 'StickerCode', dm: '贴码' }),
    value: 'PASTE_CODE',
  },
  {
    label: $i18n.get({ id: 'CombinationSale', dm: '组合售卖' }),
    value: 'COMBINATION_SALE',
  },
  {
    label: $i18n.get({ id: 'SingleSale', dm: '单个售卖' }),
    value: 'SOLD_INDIVIDUALLY',
  },
];

// 预约管理日志类型
const RESERVATION_MANAGE_OPERATE_TYPE = [
  {
    label: $i18n.get({ id: 'EmailNotification.four_px', dm: '邮箱通知' }),
    value: 'E',
  },

  {
    label: $i18n.get({ id: 'ArrivalRegistration.four_px', dm: '到货登记' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'PODUpload', dm: 'POD上传' }),
    value: 'P',
  },
];

/**
 * 责任方
 */
export const RESPONSIBLE_PARTY = [
  { label: $i18n.get({ id: 'CustomerArrivesLate', dm: '客户晚到仓' }), value: 'CLA' },
  { label: $i18n.get({ id: 'CustomerNotInWarehouse', dm: '客户未到仓' }), value: 'CNA' },
  { label: $i18n.get({ id: '4PXFirstJourneyLateToWarehouse', dm: '4PX头程晚到仓' }), value: '4PXLA' },
  { label: $i18n.get({ id: '4PXHeadJourneyNotToWarehouse', dm: '4PX头程未到仓' }), value: '4PXNA' },
];

const PLATE_STATUS = [
  {
    label: $i18n.get({ id: 'Punch.four_px', dm: '打托' }),
    value: 'A',
  },
  {
    label: $i18n.get({ id: 'Bulk', dm: '散装' }),
    value: 'B',
  },
  {
    label: $i18n.get({ id: 'TotsBulk', dm: '打托&散装' }),
    value: 'C',
  },
];

// 入库订单 委托单类型 businessType
export const INBOUND_BUSINESSTYPE_LIST = [
  {
    label: 'Dropshipping',
    value: 'D',
  },
  {
    label: 'FB4',
    value: 'F',
  },
  {
    label: 'FBA Pro',
    value: 'P',
  },
  {
    label: $i18n.get({ id: 'TheFBALibrary', dm: 'FBA越库' }),
    value: 'PC',
  },
  {
    label: $i18n.get({ id: 'AEOverseasCustodyWarehouse', dm: 'AE海外托管仓发' }),
    value: 'SW',
  },
];

// 入库单详情 质检结果 qcResult
export const INBOUND_DETAILS_QCRESULT = [
  {
    label: $i18n.get({ id: 'Qualified', dm: '合格' }),
    value: 'QUALIFIED',
  },
  {
    label: $i18n.get({ id: 'Unqualified', dm: '不合格' }),
    value: 'UNQUALIFIED',
  },
];

export {
  STOCK_QUALITY,
  BUSINESSTYPE,
  NEW_PUTAWAY_TYPE,
  PUTON_TYPE,
  PUTAWAY_TYPE,
  ABNOR_PUTON_TYPE,
  ABNOR_PUTON_TYPE_LIST,
  PUTAWAY_ABNOR_TIME,
  NEW_RECEIPT_TYPE,
  RECEIPT_NO,
  RECEIPT_TYPE,
  RECEIPT_ANBOR_TIME,
  DISCHARGE_ANBOR_TIME,
  TAB_STATUS,
  OPERATIONCODE,
  INBOUNDSERVICE,
  CARGO_TYPE_LIST,
  PAKEAGE_TAB,
  RESERVATIONTYPE,
  SHOUHUOSTATE,
  CONTAINERTYPE,
  YIKUSTATUS,
  MOVEKU_ACTION_STATUS,
  YIKUALLSTATUS,
  YUYUENOTYPE,
  TRANSPORTYPE,
  TWOTRANSPORTYPE,
  RECEVINGFULFILLSTATUS,
  CARRIERTYPE,
  ARRIVECONFIRMSTATUS,
  DIFFERENCE_STATUS,
  INBOUND_SOURELIST,
  PAKEAGE_TAB_STATUS,
  BOUNCE_RECEIPT_ORDER,
  BOUNCE_RECEIPT_TIME,
  BOUNCE_RECEIPT_STATUS,
  BOUNCE_PUTAWAY_ORDER,
  BOUNCE_PUTAWAY_TIME,
  BOUNCE_PUTAWAY_STATUS,
  BOUNCE_PUTAWAY_DETAIL_ORDER,
  BOUNCE_PUTAWAY_ABNOR_ORDER,
  BOUNCE_QUALITY_STATUS,
  BOUNCE_PUTAWAY_TYPE,
  BOUNCE_OPERATE_STEP,
  IBOUND_OPERATE_CONTENT,
  RESERVATIONTYPES,
  RECEIPT_GOODS_TAB,
  GOOD_ABNOR_STATUS,
  GOOD_ABNORMAL_CATEGORIES,
  GOOD_ABNOR_TYPE,
  LOG_DEPARTMENT,
  LOG_REMARK,
  DEAL_SUGGESTION,
  LOGISTICS_PACKAGING,
  YUYUESTATUS,
  BUSINESSTYPEPRODULE,
  GOODSABNOR_YES_NO,
  REPORT_LIST,
  EATIMES,
  PACKJOBSTATUS,
  BUSINESSTYPES,
  ASSORTJOBSTATUS_LIST,
  ISBATTERYS,
  UNLOADTYPES,
  EVENT_CODES,
  RECEIPT_ANBOR_TAB,
  INBOUND_TALLY_STATUS,
  TALLY_STATUS,
  TALLY_EXCEPTION_TYPE,
  TALLY_SUBEXCEPTION_TYPE,
  TALLY_EXCEPTION_DEAL_TYPE,
  RESERVATION_MANAGE_OPERATE_TYPE,
  RESERVATION_LEAD_SEAL_STATUS,
  RESERVATION_HAS_POD,
  DEAL_OPINION_CATEGORIES,
  RECEIVE_PATH,
  PLATE_STATUS,
};
